import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import '@/assets/styles/theme.css'
import '@/assets/styles/list.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import action from './directives/action'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.directive('action', action)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
